import { Injectable } from '@angular/core';
import { BaseHttpApiService } from './base-http.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { DateFormatHelperService } from './date-format-helper.service';
import { MorayEastInstructionsGridDTO } from '../Dtos/moray-east/instructions-grid-dto';
import { MorayEastInstructionDTO } from '../Dtos/moray-east/instructions-dto';

@Injectable({
  providedIn: 'root'
})
export class MorayEastService extends BaseHttpApiService {

  constructor(private httpClient: HttpClient,
    private dateHelper: DateFormatHelperService) { super();}

  GetActiveAndFutureInstructions(): Observable<MorayEastInstructionsGridDTO[]>
  {    
    return this.httpClient.get<MorayEastInstructionsGridDTO[]>(`${this.apiURL}MorayEast/Instructions`);
  }

  GetInstructionsByDateRange(from: Date, to: Date): Observable<MorayEastInstructionsGridDTO[]> {
    from.setHours(0, 0, 0, 0); // Set time to 00:00
    to.setHours(23, 59, 59, 999); // Set time to 23:59
    return this.httpClient.get<MorayEastInstructionsGridDTO[]>(`${this.apiURL}MorayEast/Instructions/${this.dateHelper.GetAPIFormat(from)}/${this.dateHelper.GetAPIFormat(to)}`);
  }

  GetInstructionById(instructionId:number|string): Observable<MorayEastInstructionDTO>{
    return this.httpClient.get<MorayEastInstructionDTO>(`${this.apiURL}MorayEast/${instructionId}`)
  }

  SaveInstruction(instruction: MorayEastInstructionDTO) {
   
    if (typeof instruction.issuedFrom === 'string') {
      instruction.issuedFrom = new Date(instruction.issuedFrom);
    }
    instruction.issuedFrom.setUTCHours(0, 0, 0, 0); // Set time to 00:00 GMT
    debugger;
    if (instruction.issuedTo) {
      if (typeof instruction.issuedTo === 'string') {
        instruction.issuedTo = new Date(instruction.issuedTo);
      }
      instruction.issuedTo.setUTCHours(23, 59, 59, 999);
    } // Set time to 23:59
   return this.httpClient.post<object>(`${this.apiURL}MorayEast`, instruction);
  }

  ChangeStatus(instructionId:number|string, status: string){
    return this.httpClient.put<object>(`${this.apiURL}MorayEast/SetStatus?instructionId=${instructionId}&status=${status}`,'') 
  }

  ApplyToEDT(instructionId: string | number) {
    return this.httpClient.put<object>(`${this.apiURL}MorayEast/ApplyToEDT?instructionId=${instructionId}`, '')
  }
}
